import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { GenderInput } from './GenderInput';

export function GenderField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return <GenericInputField<TValues> {...props} Input={GenderInput} />;
}
